"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = NuiClient;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _nuiAuth = require("@concur/nui-auth");
var _nuiIntlRuntime = _interopRequireWildcard(require("@concur/nui-intl-runtime"));
var _safeCookies = _interopRequireDefault(require("@concur/safe-cookies"));
var _reactRouterDom = require("react-router-dom");
var _userPreferences = require("../modules/userPreferences");
var _RouteHandler = _interopRequireDefault(require("./RouteHandler"));
var _getShellRoutes = require("../util/getShellRoutes");
var _createRoutesFromChildren = _interopRequireDefault(require("../util/createRoutesFromChildren"));
var _UseRoutes = _interopRequireDefault(require("./UseRoutes"));
var _ErrorHandler = _interopRequireDefault(require("./ErrorHandler"));
var _getErrorStore = require("../util/getErrorStore");
var _config = _interopRequireDefault(require("../config"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function NuiClient(_ref) {
  var store = _ref.store,
    children = _ref.children,
    mapStateToError = _ref.mapStateToError,
    routerProps = _ref.routerProps,
    routes = _ref.routes,
    _ref$setBaseUrl = _ref.setBaseUrl,
    setBaseUrl = _ref$setBaseUrl === void 0 ? false : _ref$setBaseUrl,
    _ref$initialState = _ref.initialState,
    initialState = _ref$initialState === void 0 ? {} : _ref$initialState;
  (0, _safeCookies.default)();
  var resilientStore = store || (0, _getErrorStore.getErrorStore)(initialState);
  var state = resilientStore.getState();
  var _state$userPrefs = state.userPrefs,
    userPrefs = _state$userPrefs === void 0 ? {} : _state$userPrefs,
    baseUrl = state.baseUrl;
  var isLoggedIn = userPrefs.isLoggedIn,
    ConcurId = userPrefs.ConcurId,
    companyUUID = userPrefs.companyUUID;

  // Fetch user prefs if they do not exist
  (0, _react.useEffect)(function () {
    if (Object.keys(userPrefs).length === 0) {
      var userPrefsAction = (0, _userPreferences.fetchUserPrefs)();
      resilientStore.dispatch(userPrefsAction);
    }
  }, []);
  var localeData = (0, _nuiIntlRuntime.getLocaleData)(state);
  if (isLoggedIn && window && window.newrelic) {
    window.newrelic.setCustomAttribute('MBP', ConcurId);
    window.newrelic.setCustomAttribute('MBC', companyUUID);
  }

  // If routes is a function, get result of function
  var routesResult = typeof routes === 'function' ? routes() : routes;

  // Convert routes to a route object array if it is JSX Element
  var consumerRoutesArray = Array.isArray(routesResult) ? routesResult : (0, _createRoutesFromChildren.default)(routesResult);
  var useAnonymousErrorRoutes = _config.default.nui.use_anonymous_error_routes;
  var shellRoutesArray = setBaseUrl ? (0, _getShellRoutes.getShellRoutesArray)('', useAnonymousErrorRoutes) : (0, _getShellRoutes.getShellRoutesArray)(baseUrl, useAnonymousErrorRoutes);

  // Add shell routes
  var allRoutesArray = [].concat(_toConsumableArray(consumerRoutesArray), _toConsumableArray(shellRoutesArray));
  return /*#__PURE__*/_react.default.createElement(_reactRedux.Provider, {
    store: resilientStore,
    key: "provider"
  }, /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.default, {
    localeData: localeData
  }, /*#__PURE__*/_react.default.createElement(_ErrorHandler.default, {
    mapStateToError: mapStateToError
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "react-component-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_nuiAuth.JwtRefresher, null), /*#__PURE__*/_react.default.createElement(_reactRouterDom.BrowserRouter, _extends({}, routerProps, {
    basename: setBaseUrl ? baseUrl : ''
  }), /*#__PURE__*/_react.default.createElement(_UseRoutes.default, {
    routes: allRoutesArray
  }), children, /*#__PURE__*/_react.default.createElement(_RouteHandler.default, {
    routes: allRoutesArray
  }))))));
}
NuiClient.propTypes = {
  children: _propTypes.default.any,
  routes: _propTypes.default.any,
  store: _propTypes.default.object,
  initialState: _propTypes.default.object,
  mapStateToError: _propTypes.default.func,
  shouldManageFocusOnRouteChange: _propTypes.default.bool
};